<script>
    import {GalleryIcon, ValuesIcon, WhoIcon} from "./icons";
    import {onMount} from "svelte";

    const sidebarType = {
        WHO: 1,
        VALUES: 2,
        GALLERY: 3,
        CONTACTS: 4
    }

    let activeType
    $: activeType = sidebarType.WHO;


    function switchWhoItem() {
        activeType = sidebarType.WHO;
    }

    function switchValuesItem() {
        activeType = sidebarType.VALUES;
    }

    function switchGalleryItem() {
        activeType = sidebarType.GALLERY;
    }

    function switchContactsItem() {
        activeType = sidebarType.CONTACTS;
    }

    onMount(async () => {
        let mainLinks = document.querySelectorAll(".sidebar div a");
        let mainSection = document.getElementById("page-content");

        let lastId;
        let cur = [];

        mainSection.addEventListener("scroll", event => {
            let fromTop = mainSection.scrollTop;

            mainLinks.forEach(link => {
                let section = document.querySelector(link.hash);

                if (
                    section.offsetTop <= fromTop &&
                    section.offsetTop + section.offsetHeight > fromTop
                ) {
                    switch (link.hash) {
                        case "#whoWeAre":
                            switchWhoItem();
                            break;
                        case "#values":
                            switchValuesItem();
                            break;
                        case "#gallery":
                            switchGalleryItem();
                            break;
                    }
                }
            });
        });
    });

</script>

<style type="text/scss">
  .sidebar {
    position: absolute;
    right: -40px;
    top: 50%;
    margin: auto;
    z-index: 10;
    -webkit-transform: translate(0, -50%);
    -moz-transform: translate(0, -50%);
    -ms-transform: translate(0, -50%);
    -o-transform: translate(0, -50%);
    transform: translate(0, -50%);
  }

  .alt {
    display: block;
    position: relative;

    &:hover {
      span[data-active="false"] {
        opacity: 1;
      }
    }

    > span {
      display: block;
      transition: 250ms;
      position: absolute;
      height: 32px;
      top: 24px;
      left: 75px;
      background-color: var(--yellow);
      box-shadow: 0 2px 8px rgba(40, 41, 61, 0.04), 0 16px 24px rgba(96, 97, 112, 0.16);
      border-radius: 16px;
      font-family: "Roboto-Medium", sans-serif;
      font-size: 14px;
      line-height: 32px;
      color: var(--sapphire);
      padding: 0 8px;
      opacity: 0;
      z-index: 10;
    }
  }

  .who {
    width: 90px;
  }

  @media screen and (max-width: 1919px) {
    .alt > span {
      height: 32px;
      top: 24px;
      left: 75px;
      border-radius: 16px;
      font-size: 14px;
      line-height: 32px;
      padding: 0 8px;
    }
  }

  @media screen and (max-width: 1024px) {
    .sidebar {
      display: none;
    }
  }
</style>

<div class="sidebar">
    <div class="alt" on:click={switchWhoItem}>
        <a href="#whoWeAre">
            <WhoIcon isActive={activeType === sidebarType.WHO}/>
        </a>
        <span class="who" data-active={activeType === sidebarType.WHO}>Who we are</span>
    </div>
    <div class="alt" on:click={switchValuesItem}>
        <a href="#values">
            <ValuesIcon isActive={activeType === sidebarType.VALUES}/>
        </a>
        <span class="values" data-active={activeType === sidebarType.VALUES}>Values</span>
    </div>
    <div class="alt" on:click={switchGalleryItem}>
        <a href="#gallery">
            <GalleryIcon isActive={activeType === sidebarType.GALLERY}/>
        </a>
        <span class="gallery" data-active={activeType === sidebarType.GALLERY}>Gallery</span>
    </div>
    <!--
    <a href="#contacts">
        <div class="alt" on:click={switchContactsItem}>
            <ContactsIcon isActive={activeType === sidebarType.CONTACTS}/>
            <span class="contacts" data-active={activeType === sidebarType.CONTACTS}>Contacts</span>
        </div>
    </a>
    -->
</div>
